import { ReactNode, createContext, useContext, useMemo, useState } from 'react';

type SessionContextType = {
    tenantId: string | undefined;
};

const SessionContext = createContext<SessionContextType>({
    tenantId: undefined,
});

type SessionContextProviderProps = {
    children: ReactNode;
    initialValue: SessionContextType;
};

export const useSession = () => {
    return useContext(SessionContext);
};

const SessionContextProvider = ({
    initialValue,
    children,
}: SessionContextProviderProps) => {
    const [value, setValue] = useState(initialValue);

    const providerValue = useMemo<SessionContextType>(() => {
        return {
            tenantId: value.tenantId,
            updateValue: setValue,
        };
    }, [value.tenantId]);

    return (
        <SessionContext.Provider value={providerValue}>
            {children}
        </SessionContext.Provider>
    );
};

export default SessionContextProvider;
